import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { SidebarWidth } from "../sidebar/Sidebar.style";

// A workspace surface: sits BESIDE the rail (offset by the sidebar width) so the
// rail stays visible. Contrast with FullScreenLayout, which covers everything
// (kept for immersive surfaces like the media/video preview).
export const WorkspaceRoot = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: SidebarWidth,
  background: theme.palette.background.default,
  zIndex: theme.zIndex.modal,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxShadow: "-2px 0 10px rgba(0,0,0,0.08)",
}));

export const WsHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "12px 16px",
  borderBottom: `1px solid ${theme.palette.divider}`,
  fontSize: 13,
  color: theme.palette.text.secondary,
}));

export const OrgCrumb = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 14,
  color: theme.palette.primary.main,
  cursor: "pointer",
  "&:hover": { textDecoration: "underline" },
}));

export const WsBody = styled(Box)({
  flex: 1,
  display: "flex",
  overflow: "hidden",
});

export const WsContent = styled(Box)({
  flex: 1,
  overflow: "auto",
});
